import React, { useState, useEffect } from 'react';
import { Box, IconButton, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ImageMapWithModal from '../ImageMap/ImageMapWithModal';

const StyledPaper = styled(Paper)(({ theme, width, height }) => ({
  position: 'relative',
  width: width || '100%',
  height: height || '400px',
  overflow: 'hidden',
  borderRadius: '20px',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
}));

const NavigationButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
  width: 30,
  height: 30,
  borderRadius: 0,
  zIndex: 10,
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
  },
}));

const SlideshowWithModal = ({ 
  images, 
  interval = 5000, 
  autoPlay = true, 
  imageMaps = [], 
  width = '100%', 
  height = '400px',
  usePercentageCoords = false
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!autoPlay) return;

    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, interval);

    return () => clearInterval(timer);
  }, [images.length, interval, autoPlay]);

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  return (
    <StyledPaper width={width} height={height}>
      <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
        <ImageMapWithModal
          imageSrc={images[currentIndex]}
          imageAlt={`Slide ${currentIndex + 1}`}
          areas={imageMaps[currentIndex] || []}
          width="100%"
          height="100%"
          usePercentageCoords={usePercentageCoords}
          style={{
            objectFit: 'cover',
            width: '100%',
            height: '100%'
          }}
        />
        
        <NavigationButton
          onClick={handlePrevious}
          sx={{ left: 0, height: 30, width: 30 }}
        >
          <ArrowBackIosNewIcon />
        </NavigationButton>
        <NavigationButton
          onClick={handleNext}
          sx={{ right: 0, height: 30, width: 30 }}
        >
          <ArrowForwardIosIcon />
        </NavigationButton>
      </Box>
    </StyledPaper>
  );
};

export default SlideshowWithModal; 